export const PURCHASE_INTREST_CALCULATION_REPORT_REQUEST = 'PURCHASE_INTREST_CALCULATION_REPORT_REQUEST';
export const PURCHASE_INTREST_CALCULATION_REPORT_SUCCESS = 'PURCHASE_INTREST_CALCULATION_REPORT_SUCCESS';
export const PURCHASE_INTREST_CALCULATION_REPORT_FAILURE = 'PURCHASE_INTREST_CALCULATION_REPORT_FAILURE';